import tw from 'twin.macro';

export const H4 = tw.h4`lg:text-2xl text-xl 2xl:text-4xl font-medium`;

export const H2 = tw.h2`lg:text-4xl text-3xl 2xl:text-6xl
 my-2 lg:my-4 lg:tracking-wider tracking-widest font-medium text-adminsecondary`;

export const NotimetableWrap = tw.div`text-center mx-auto mt-6 pb-6`;

export const Oops = tw(H2)`text-red-600!`;

export const H5 = tw(H4)`my-4`;

export const NodataSVG = tw.img`object-contain -mt-1 w-72 mx-auto h-80`;
